import { Component, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbActiveModal, NgbModal, NgbPagination } from '@ng-bootstrap/ng-bootstrap';
import { ProtuneApiService } from '../../services/protune-api.service';
import { CarTrackSettings } from '../../models/car-track-settings';
import { SuspensionSettings } from '../../models/suspension-settings';
import { DrivetrainSettings } from '../../models/drivetrain-settings';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SavedSettings } from '../../models/saved-settings';
import { ConfirmationModalComponent } from '../confirmation-modal/confirmation-modal.component';
import { PagedDataResult } from '../../models/paged-data-result';
import { AppSubscription, AuthService } from '../../services/auth.service';


@Component({
  selector: 'app-saved-settings-modal',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, NgbPagination],
  templateUrl: './saved-settings-modal.component.html',
  styleUrl: './saved-settings-modal.component.scss'
})
export class SavedSettingsModalComponent {
  @Input() mode: SavedSettingsMode;
  @Input() carTrackSettings: CarTrackSettings;
  @Input() suspensionSettings: SuspensionSettings;
  @Input() drivetrainSettings: DrivetrainSettings;

  @Output() savedSettingsId: number | null;
  @Output() name: string;
  @Output() selectedSavedSettings: SavedSettings;

  title: string;
  savedSettings: PagedDataResult<SavedSettings>
  pageSize: number = 15;
  page: number = 1;

  appSubscription: AppSubscription;

  constructor(private activeModal: NgbActiveModal, private modalService: NgbModal, private apiService: ProtuneApiService, private authService: AuthService) {

  }

  public get SavedSettingsMode() {
    return SavedSettingsMode;
  }

  ngOnInit(): void {
    this.authService.getSubscription()
      .subscribe(appSubscription => this.appSubscription = appSubscription);

    if (this.mode == SavedSettingsMode.load) {
      this.title = 'Load Settings';

      this.search();

    } else {
      this.title = 'Save Settings';
    }
  }

  search() {
    this.apiService.getSavedSettings(this.page, this.pageSize)
      .subscribe({
        next: res => {
          this.savedSettings = res;
        }, error: err => console.log(err)
      })
  }

  selectSavedSettings(savedSettings: SavedSettings) {
    if (this.selectedSavedSettings?.id == savedSettings.id) {
      this.selectedSavedSettings = null;
    }
    else {
      this.selectedSavedSettings = savedSettings;
    }
  }

  save() {
    this.apiService.saveSettings(this.savedSettingsId, this.name, this.carTrackSettings, this.suspensionSettings, this.drivetrainSettings)
      .subscribe({
        next: (savedSettingsId: number) => {
          this.activeModal.close({
            savedSettingsId: savedSettingsId,
            name: this.name
          });
        }, error: err => console.log(err)
      });
  }

  load() {
    this.activeModal.close(this.selectedSavedSettings);
  }

  delete(savedSetting: SavedSettings, $event: Event) {
    $event.stopPropagation();

    const modal = this.modalService.open(ConfirmationModalComponent);
    modal.componentInstance.title = 'Delete Saved Settings';
    modal.componentInstance.message = `Are you sure you want to delete ${savedSetting.name} settings?`;

    modal.closed.subscribe({
      next: (result: boolean) => {
        if (result == true) {
          this.apiService.deleteSavedSettings(savedSetting.id)
            .subscribe({
              next: () => {
                var idx = this.savedSettings.data.findIndex(ss => ss.id == savedSetting.id);
                this.savedSettings.data.splice(idx, 1);
              }
            })
        }
      }
    })
  }

  close() {
    this.activeModal.dismiss();
  }
}


export enum SavedSettingsMode {
  load = 0,
  save = 1
}
